import { FocusOrigin } from "@angular/cdk/a11y";
import { Direction } from "@angular/cdk/bidi";
import { EventEmitter, InjectionToken, TemplateRef } from "@angular/core";

export type MenuPositionX = 'before' | 'after';

export type MenuPositionY = 'above' | 'below';

/** Injection token used to provide the parent menu to menu items. */
export const ICC_MENU_PANEL = new InjectionToken<MenuPanel>('ICC_MENU_PANEL');

export interface MenuPanel<T = any> {
    xPosition: MenuPositionX;
    yPosition: MenuPositionY;
    overlapTrigger: boolean;
    templateRef: TemplateRef<any>;
    readonly closed: EventEmitter<void | 'click' | 'keydown' | 'tab'>;
    parentMenu?: MenuPanel | undefined;
    direction?: Direction;
    focusItem: (origin?: FocusOrigin) => void;
    resetActiveItem: () => void;
    setPositionClasses?: (x: MenuPositionX, y: MenuPositionY) => void;
    backdropClass?: string;
    overlayPanelClass?: string | string[];
    hasBackdrop?: boolean;
    readonly panelId?: string;
    indexFocusItem?:number | null;
    setIndexItem:(index:number|null) => void;
    getChildIndex:(node:any) => number|null;
}